(function () {
    'use strict';

    var module = angular.module('uwAgenda.help', ['uwAgenda.global']);
    
    // help category enum
    module.constant('HelpCategoryEnum', {
        "TaskGeneral": { name: "Task General", value: 0 },
        "UrgentTodo": { name: "Urgent Todo", value: 1 },
        "DayTask": { name: "Day Task", value: 2 },
        "AgendaGeneral": { name: "Agenda General", value: 3 },
        "AgendaDay": { name: "Agenda Day", value: 4 },
        "AgendaWeek": { name: "Agenda Week", value: 5 },
        "FirstFreeAppointments": { name: "First Free Appointments", value: 6 },
        "AppointmentListNew": { name: "Appointment List New", value: 7 },
        "AppointmentListState": { name: "Appointment List State", value: 8 },
        "AppointmentListDeleted": { name: "Appointment List Deleted", value: 9 },
        "AppointmentListUrgent": { name: "Appointment List Urgent", value: 10 },
        "Email": { name: "Email", value: 11 },
        "Webmail": { name: "Webmail", value: 12 },
        "UserGeneral": { name: "User General", value: 13 },
        "UserProfileSettings": { name: "User Profile Settings", value: 14 },
        "UserAccountSettings": { name: "User Account Settings", value: 15 },
        "GoogleMap": { name: "Google Map", value: 17 },
        "Website": { name: "Website", value: 18 },
        "AgendaDownload": { name: "Agenda Download", value: 19 },
        "PopularDownload": { name: "Popular Download", value: 20 },
        "AgendaSettings": { name: "Agenda Settings", value: 21 },
        "AgendaLabel": { name: "Agenda Label", value: 22 },
        "AppointmentType": { name: "Appointment Type", value: 23 },
        "WeekScheme": { name: "Week Scheme", value: 24 },
        "WeekSchemeDay": { name: "Week Scheme Day", value: 25 },
        "ExtraDay": { name: "Extra Day", value: 26 },
        "SharedAgenda": { name: "Shared Agenda", value: 27 },
        "CallsMessages": { name: "Calls Messages", value: 28 },
        "News": { name: "News", value: 29 },
        "Statistic": { name: "Statistic", value: 30 },
        "ProgramInfo": { name: "Program Info", value: 37 },
        "UI": { name: "UI", value: 38 }
    });

    module.config(['$stateProvider', 'HelpCategoryEnum', SettingsConfig]);

    function SettingsConfig($stateProvider, HelpCategoryEnum) {
        $stateProvider
            .state('Home.Help', {
                url: 'Help',
                templateUrl: '/app/help/templates/help.template.html',
                controller: 'HelpController',
                controllerAs: 'vm',
                params: {
                    helpCategory: null
                },
                resolve: {
                    helpList: ['HelpService', function (HelpService) {
                        return HelpService.query("");
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'faq' | translate}}"
                }
            });
    }

})();